module.exports = __webpack_public_path__ + "static/media/ITALY.f04de15f.svg";